import React from 'react';
import PageLayout from '../../components/common/PageLayout';
import ProductsReplenishContainer from '../blocks/ProductsReplenishContainer';
import { ProductsReplenishPagePanel } from '../panels/ProductsReplenishPagePanel';

export function ProductsReplenishPageContainer() {
  return (
    <PageLayout top={<ProductsReplenishPagePanel />}>
      <div className="top">
        <ProductsReplenishContainer />
      </div>
    </PageLayout>
  );
}
